webpackJsonp([238583840429679],{

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Search = __webpack_require__(78);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Components
	
	
	var PageWrapper = _styledComponents2.default.section(_templateObject);
	
	var StandaloneSearchPage = function StandaloneSearchPage() {
	
	  return _react2.default.createElement(
	    PageWrapper,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'The Search Component'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This component survives through the Gatsby build, it\'s loaded in the bundle as a React component.'
	    ),
	    _react2.default.createElement(_Search2.default, null)
	  );
	};
	
	exports.default = StandaloneSearchPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-jamstack-search-js-9e5443eb5bcc4f07fbff.js